(function () {
  var PROTECTED_SELECTOR = '.tm_product-view-img img, .tm_product_view-thumbs-img img';

  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest(PROTECTED_SELECTOR)) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest(PROTECTED_SELECTOR)) e.preventDefault();
  });
})();

// new zoom

if (typeof Drift !== 'undefined' && $(window).width() > 991) {
  document.querySelectorAll('.tm_pro-main-img').forEach(function (zoomImg) {
    new Drift(zoomImg, {
      paneContainer: document.querySelector('.tm_product-desc'),
      inlinePane: 500,
      inlineOffsetY: -85,
      containInline: true,
      hoverBoundingBox: true
    });

  });
}

// new zoom

$(document).ready(function () {

  // start new zoom

  $(".tm_product-view-img").on("click", function () {
    $(this).children(".gallery-image").toggleClass('zoom');
    if ($(this).children(".gallery-image").hasClass("zoom")) {
      $(this).children(".gallery-image").css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
    } else {
      $(this).children(".gallery-image").css({ transform: "scale(1)" });
    }
  })
    .on("mousemove", function (e) {
      $(this).children(".gallery-image").css({ "transform-origin": ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + "% " + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + "%" });
    });

  $(document).mouseup(function (e) {
    var clickplace = $(".tm_product-view-img");
    if (!clickplace.is(e.target) && clickplace.has(e.target).length == 0) {
      $(".gallery-image").css({ transform: "scale(1)" });
      $(".gallery-image").removeClass('zoom');
    }
  });
  if ($(window).width() < 992) {
    $(".tm_product-view-img img").on("click", function () {
      $(this).css('transform-origin', '0 0 0')
    });
  }

  // end new zoom


  $('.popup_close').click(function () {
    $('.order_popup_pos').removeClass('show')
  });

  $(document).mouseup(function (e) {
    var clickplace = $(".order_popup_pos");
    if (!clickplace.is(e.target) && clickplace.has(e.target).length == 0) {
      $('.order_popup_pos').removeClass('show')
    }
  });

  if ($(window).width() > 768) {


    $('#CustomerEmail').focus();
    $('#RecoverEmail').focus();
    $('#ragister_email_id').focus();
    $('#get_start').click(function () {
      $('#RegisterForm-FirstName').focus();
    });
    $('#create').click(function () {
      $('#First_last_name').focus();
    });

  }


  // $('.con_btn button').attr('disabled','disabled');
  $('#CustomerEmail').keypress(function (e) {
    $('.con_btn button').removeAttr('disabled', 'disabled');
  });

  // $('.con_btn button').click(function(){
  //   $('.con_btn').hide();
  //   $('.field_hide').addClass('active');
  //   $('.email_hide').hide();
  //   $('.signin_text').hide();
  //   $('.creat_acc').hide();
  //   $('.forget_hide').hide();
  //   $('.login_bottom').hide();
  //   $('.append_hide').show();
  // });

  $(".con_btn button").click(function () {
    event.preventDefault();
  });

  // $('.back_top_btn').hide();
  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
    if (scroll > 200) {
      $('.back_top_btn').show();
    }
    else {
      $('.back_top_btn').hide();
    }
  });

  $('.main_add .border_change').click(function () {
    $('.main_add').hide();
  });
  $('.add_canc').click(function () {
    $('.main_add').show();
    $("#main_btn").attr("aria-expanded", false);
  });


  // if( $(".cart , .collection").length > 0){
  //   $(window).on('beforeunload', function(){
  //     $(window).scrollTop(0);
  //   });
  // }
  $(document).on("click", ".back_top_btn", function (e) {
    e.preventDefault();
    $(window).scrollTop(-30);
  })
  // $(window).scroll(function (event) {
  //   var hedaer_scroll = $(window).scrollTop();
  //   if(hedaer_scroll > 120){
  //     $('.tm_header').addClass('header_fixed');
  //     $('.tm_header_bottom').hide();
  //   }
  //   else{
  //     $('.tm_header').removeClass('header_fixed');
  //     $('.tm_header_bottom').show();
  //   }
  // });


  $('.page-contact-us , .customers-addresses').addClass('page_loader')

  setTimeout(() => {
    $('.page-contact-us , .customers-addresses').removeClass('page_loader')
  }, 2000);





  var dataName = $('body').attr("data-name");
  // alert(dataName);
  var dataEmail = $('body').attr("data-email");
  // alert(dataEmail);
  $('input[placeholder="Name"]').each(function (e) {
    $(this).val(dataName)
  })


  // $('button.needsclick').on('click', function() {
  //    $(this).hide();
  // });


  // press enter to next input 


  //   $('input').on("keypress", function(e) {
  //       /* ENTER PRESSED*/
  //       if (e.keyCode == 13) {
  //           /* FOCUS ELEMENT */
  //           var inputs = $(this).parents("form").eq(0).find(":input");
  //           var idx = inputs.index(this);

  //           if (idx == inputs.length - 1) {
  //               inputs[0].select()
  //           } else {
  //               inputs[idx + 1].focus(); //  handles submit buttons
  //               inputs[idx + 1].select();
  //           }
  //           return false;
  //       }
  //   });


  // press enter to next input 


  // window.onbeforeunload = function () {
  //     window.scrollTo(0, 0);
  // }; 

  // collection page sort by js
  $(document).on("click", ".sort_list", function (e) {
    $(this).siblings().removeAttr("selected", "selected");
    $(this).attr("selected", "selected");
    $("body").addClass("page_loader");
    // document.getElementById('AjaxinateContainer').classList.add('loading');
    setTimeout(() => {
      $("body").removeClass("page_loader");
      // document.getElementById('AjaxinateContainer').classList.remove('loading');
    }, 800);
  });


  $(document).on("click", "form.klaviyo-form button", function () {
    setTimeout(() => {
      // $('.tm_contact-us , .tm_contact-dtl h2 , .tm_contact-close , .footer__content-top , .back_to_top , .footer').hide();
      $('.tm_contact-us , .tm_contact-dtl h2 , .tm_contact-close , .back_to_top').hide();
      $('.tm_contact-dtl').css('padding-top', '60px')
      $('.page-contact-us').addClass('height')
    }, 550);
  });

  $("#ragister_email_id").keydown(function (e) {
    if (e.keyCode == 13) {
      $('#get_start').click();
      return false;
    }
  });

  // $("#CustomerPassword").keydown(function (e) {
  //   if (e.keyCode == 13) {
  //     $('.submit_btn').click();
  //     return false;
  //   }
  // });


  setTimeout(() => {
    if ($(".page-contact-us").length > 0) {
      $('input').on("keypress", function (e) {
        /* ENTER PRESSED*/
        if (e.keyCode == 13) {
          /* FOCUS ELEMENT */
          var inputs = $(this).parent("form").eq(0).find(":input");
          var idx = inputs.index(this);

          if (idx == inputs.length - 1) {
            inputs[0].select()
          } else {
            inputs[idx + 1].focus(); //  handles submit buttons
            inputs[idx + 1].select();
          }
          return false;
        }
      });
    }
  }, 10);

  if ($(".cart").length > 0) {

    if ($(window).width() < 576) {

      $(window).on('beforeunload', function () {
        $(window).scrollTop(0);
      });

    }

  }



  // if( $(".cart").length > 0){
  //   if( $(".not_login.cart ").length > 0){
  //     document.location.href="/";
  //   }
  // }

  $('.forget').click(function () {
    $('.login_bottom').hide();
    $('.creat_acc').hide();
    $(".login .wrong_email").hide();
  });

  setTimeout(function () {
    if (location.hash == "#buy") {
      $("[data-order='order-2']").trigger("click");
    } else if (location.hash == "#not-shipped") {
      $("[data-order='order-3']").trigger("click");
    } else if (location.hash == "#cancel-order") {
      $("[data-order='order-4']").trigger("click");
    } else {
      $("[data-order='order-1']").trigger("click");
    }
  }, 100);


  if ($("#showPassword").length > 0) {
    document.getElementById('showPassword').onclick = function () {
      if (this.checked) {
        document.getElementById('pass').type = "text";
      } else {
        document.getElementById('pass').type = "password";
      }
    };
  }

  $('.con_btn button').click(function () {
    $('#CustomerPassword').focus();
    $(".main_login_error").hide();
  });



  if ($(".customers-register").length > 0) {
    if ($(window).width() < 576) {
      $('.tm_business-acc input').click(function () {
        $('html, body').animate({ scrollTop: '+=100px' }, 0);
      });
    }
  }

  // Quantity Popup Logic
  $(document).on('click', '.mobile_qty', function (e) {
    if ($(e.target).closest('.jS_qty_manual').length) return;
    if ($(this).hasClass('qty-unavailable')) return;

    // Lock body
    $("html, body").addClass("new_layer");

    // List visibility is already kept in sync with the selected variant's
    // stock by applyQtyStockLimit() in new_product_page_section.liquid
    // (runs on load and on every variant change) - don't re-show everything here.

    // Set active state
    var currentVal = $('.dropdown_qtycls_mobile').val();
    $('.qty_bottom li').removeClass('active');
    $('.qty_bottom li').filter(function () {
      return $(this).attr('data-val') == currentVal;
    }).addClass('active');

    $('.qty_pos').css('display', 'flex');
  });

  // Close popup logic (X button and background)
  $(document).on('click', '.qty_top .close, .qty_pos', function (e) {
    if (e.target === this || $(this).hasClass('close') || $(this).closest('.close').length) {
      $('.qty_pos').hide();
      // Unlock body
      $("html, body").removeClass("new_layer");
    }
  });

  // Select quantity from list
  $(document).on('click', '.qty_bottom li', function () {
    $(this).addClass('active').siblings().removeClass('active');
    $('.qty_pos').hide();
    // Unlock body
    $("html, body").removeClass("new_layer");

    var val = $(this).attr('data-val');
    var deskSel = document.querySelector('.dropdown_qtycls'); // Sync to desktop dropdown
    if (deskSel) { deskSel.value = val; deskSel.dispatchEvent(new Event('change', { bubbles: true })); }
    $(".dropdown_qtycls_mobile").val(val).trigger('change');
  });

  // Initialize custom desktop qty on load
  $('.qty-dropdown-custom').each(function () {
    var $container = $(this);
    var $select = $container.siblings('.dropdown_qtycls');
    var val = $select.val() || 1;
    $container.find('.qty-value').text(val);
    $container.find('.qty-dropdown-item').removeClass('active');
    $container.find('.qty-dropdown-item[data-val="' + val + '"]').addClass('active');
  });

  // Selection from list
  $(document).on('click', '.qty-dropdown-item', function () {
    var val = $(this).attr('data-val');
    var $container = $(this).closest('.qty-dropdown-custom');

    // Update local UI
    $container.find('.qty-value').text(val);
    $(this).addClass('active').siblings().removeClass('active');
    $container.find('.qty-dropdown-list').removeClass('show');
    $container.find('.qty-dropdown-btn').removeClass('open');

    // Sync with hidden select (native event so the section's addEventListener handler also fires)
    var $select = $container.siblings('.dropdown_qtycls');
    $select.val(val);
    if ($select[0]) $select[0].dispatchEvent(new Event('change', { bubbles: true }));

    // Sync with mobile if exists
    $(".dropdown_qtycls_mobile").val(val).trigger('change');
  });

  // Desktop Dropdown Toggle
  $(document).on('click', '.qty-dropdown-btn', function (e) {
    e.stopPropagation();
    var $list = $(this).siblings('.qty-dropdown-list');

    // Close other dropdowns
    $('.qty-dropdown-list').not($list).removeClass('show');
    $('.qty-dropdown-btn').not(this).removeClass('open');

    $(this).toggleClass('open');
    $list.toggleClass('show');

    // Scroll the selected value into view (same as Amazon)
    if ($list.hasClass('show')) {
      var active = $list.find('.qty-dropdown-item.active')[0];
      if (active) $list.scrollTop(Math.max(0, active.offsetTop - 50));
    }
  });

  // Keep custom dropdown UI in sync when qty changes from the select or manual input
  $(document).on('change', '.dropdown_qtycls, .pdpjs-qty__num', function () {
    var $select = $('.dropdown_qtycls');
    var $custom = $('.qty-dropdown-custom');
    if (!$select.length || !$custom.length) return;
    var val = $select.val() || 1;
    $custom.find('.qty-value').text(val);
    $custom.find('.qty-dropdown-item').removeClass('active');
    $custom.find('.qty-dropdown-item[data-val="' + val + '"]').addClass('active');
  });

  // Close dropdown on click outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.qty-dropdown-custom').length) {
      $('.qty-dropdown-list').removeClass('show');
      $('.qty-dropdown-btn').removeClass('open');
    }
  });

  // --- Quantity picker follows the variant's availability -------------------
  // The buy box renders the quantity picker whether or not the selected
  // variant can be bought, so on a sold-out variant it stayed clickable:
  // opening the desktop list (or the mobile bottom sheet) on top of a
  // "Sold out" buy box left a picker with nothing valid to choose and threw
  // the layout out. The add-to-basket button is already the single source of
  // truth for availability - Liquid disables it on load and global.js's
  // toggleAddButton() re-disables it on every variant change - so mirror that
  // rather than working availability out a second time and risking the two
  // disagreeing.
  function syncQtyAvailability() {
    var submit = document.querySelector('.product-form__buttons .product-form__submit');
    if (!submit) return;
    var soldOut = submit.disabled || submit.getAttribute('aria-disabled') === 'true';

    $('.qty-dropdown-btn').prop('disabled', soldOut);
    $('.dropdown_qtycls, .dropdown_qtycls_mobile').prop('disabled', soldOut);
    $('.jS_qty_manual .quantity__button, .jS_qty_manual .quantity__input').prop('disabled', soldOut);
    $('.dectop_qty').toggleClass('qty-unavailable', soldOut);
    $('.mobile_qty').toggleClass('qty-unavailable', soldOut);

    // Whatever was already open has to come down with it, otherwise switching
    // to a sold-out variant leaves an orphaned list or bottom sheet on screen.
    if (soldOut) {
      $('.qty-dropdown-list').removeClass('show');
      $('.qty-dropdown-btn').removeClass('open');
      $('.qty_pos').hide();
      $('html, body').removeClass('new_layer');
    }
  }

  var qtyBuyBox = document.querySelector('.product-form__buttons');
  if (qtyBuyBox) {
    syncQtyAvailability();
    new MutationObserver(syncQtyAvailability).observe(qtyBuyBox, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      subtree: true,
      childList: true,
    });
  }

  function commitManualQty($input) {
    var val = parseInt($input.val(), 10);
    if (!val || val < 1) val = 1;

    var $desktopInput = $('.pdpjs-qty__num');
    var $mobileInput = $('.pdpjs-qty__num_mobile');

    $desktopInput.val(val).attr('value', val).data('committedQty', val);
    $mobileInput.val(val).data('committedQty', val);

    $('.jS_qty_manual .jS_qty_update').addClass('hidden');

    if ($desktopInput[0]) $desktopInput[0].dispatchEvent(new Event('change', { bubbles: true }));
    if ($mobileInput[0]) $mobileInput[0].dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Show the Update button as soon as the number is genuinely edited. Some
  // mobile browsers fire one extra "input" event when the on-screen keyboard
  // dismisses (e.g. finalizing autocorrect) even though the value is already
  // exactly what was just committed — that spurious event was making the
  // button reappear right after Update was tapped. Guard against it by only
  // showing the button when the value actually differs from what's committed.
  $(document).on('input', '.jS_qty_manual .quantity__input', function () {
    var $this = $(this);
    var committed = $this.data('committedQty');
    var current = parseInt($this.val(), 10);
    if (committed !== undefined && current === committed) return;
    $this.closest('.jS_qty_manual').find('.jS_qty_update').removeClass('hidden');
  });

  $(document).on('click', '.jS_qty_update', function (e) {
    // stopImmediatePropagation (not just stopPropagation): jQuery delegates
    // every $(document).on(...) handler off the same single listener, so
    // stopPropagation alone does not stop sibling document-bound handlers
    // (like the "open the mobile quantity popup" one below) from also firing
    // for this same click — that was reopening the popup instead of committing.
    e.stopImmediatePropagation();
    e.preventDefault();
    commitManualQty($(this).closest('.jS_qty_manual').find('.quantity__input'));
  });

  // Enter key commits too, rather than submitting the add-to-cart form
  $(document).on('keydown', '.jS_qty_manual .quantity__input', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      commitManualQty($(this));
    }
  });

  // Clicking (or tapping, on mobile) outside the quantity box exits it and
  // commits whatever was typed
  $(document).on('click', function (e) {
    var $box = $('.jS_qty_manual').not('.hidden');
    if (!$box.length) return;
    if ($(e.target).closest('.jS_qty_manual').length) return;
    if ($box.find('.jS_qty_update').hasClass('hidden')) return;
    commitManualQty($box.find('.quantity__input'));
  });

  // Mobile quantity change handler
  $('.dropdown_qtycls_mobile').on('change', function () {
    var val = this.value;
    $('.pdpjs-qty__num_mobile').val(val);
    $('.pdpjs-qty__num').val(val).attr("value", val);

    // Switch to manual input when "50+" is selected (same as Amazon)
    if (parseInt(val) > 49) {
      $('.js_qty_dropdown_mobile').addClass("hidden");
      $('.jS_qty_input_mobile').removeClass("hidden");
      const input = $('.jS_qty_input_mobile .quantity__input');
      if (input.length) {
        // Prefill "1" and highlight it, same as Amazon/desktop, so typing replaces it
        input.val('1').data('committedQty', 1);
        input[0].focus();
        input[0].select();
      }
    } else {
      $('.js_qty_dropdown_mobile').removeClass("hidden");
      $('.jS_qty_input_mobile').addClass("hidden");
    }
  });



});

async function login(email, password, analytics_trace_id) {
  const data = new URLSearchParams({
    'customer[email]': email,
    'customer[password]': password,
    form_type: 'customer_login',
    utf8: '✓'
  });
  try {
    const response = await fetch('/account/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: data
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const result = await response.text();
    if (response.url.includes('/account/login')) {
      $(".wrong_password").css("display", "block")
      $('#CustomerPassword').val('');
    } else {
      window.location.href = '/account';
    }
  } catch (error) {
    console.error('There was a problem with the login request:', error);
    throw error;
  }
}
// -----------------

// $(document).ready(function() {
//   $('.main_submit').on('click', function(event) {
//     // event.preventDefault();
//     const email = $('#CustomerEmail').val();
//     const password = $('#CustomerPassword').val();
//     const analytics_trace_id = $('input[name="login_with_shop[analytics_trace_id]"]').val();
//     login(email, password , analytics_trace_id);
//   });
// });
// $(document).ready(function() {
//   $('.main_submit').on('click', function() {
//     document.body.classList.add('checking-mail');
//   });
// });

document.querySelectorAll('.product_def_price.money').forEach(function (el) {
  var revealTimer = null;
  var markReady = function () { el.classList.add('tm-price-ready'); };

  var reformat = function () {
    var priceVal = null;
    var liveText = String(el.textContent).replace(/,/g, '');
    var liveMatch = liveText.match(/(\d+)\.(\d{2})/);

    if (liveMatch) {
      priceVal = liveMatch[1] + '.' + liveMatch[2];
      if (el.dataset) el.dataset.price = priceVal;
    } else {
      var rawText = (el.dataset && el.dataset.price) ? el.dataset.price : el.textContent;
      var num = parseFloat(String(rawText).replace(/[^\d.]/g, ''));
      if (!isNaN(num)) {
        priceVal = (String(rawText).indexOf('.') === -1 && num > 999) ? (num / 100).toFixed(2) : num.toFixed(2);
      }
    }

    if (priceVal !== null) {
      var parts = priceVal.split('.');
      var desired = '<sup class="tm_pound-sign tm_sm-font">£</sup><span>' + parts[0] +
        '</span><sup class=" tm_price_sm tm_sm-font">' + parts[1] + '</sup>';
      if (el.innerHTML !== desired) el.innerHTML = desired;
    }
    clearTimeout(revealTimer);
    revealTimer = setTimeout(markReady, 250);
  };

  new MutationObserver(reformat).observe(el, { childList: true, characterData: true, subtree: true });
  setTimeout(markReady, 5000);
});
